import { registerView, ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { Collapse } from "react-bootstrap";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import GdprInfoViewModel from "viewModels/eshop/order/components/gdprInfoViewModel";
import ReactMarkdown from "react-markdown";

const GdprInfoView: ViewComponent<GdprInfoViewModel> = observer(({ vm }) => {
  return (
    <div className="mt-4 pt-4 pb-4" style={{ borderTop: "1px solid #E4E8EC", borderBottom: "1px solid #E4E8EC" }}>
      <div
        className="d-flex justify-content-between align-items-center"
        onClick={vm.toggle}
        style={{ cursor: "pointer" }}
        role="button"
        aria-expanded={vm.isExpanded}>
        <span className="font-weight-bold">{vm.translate("title")}</span>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: "#E4E8EC",
            transform: vm.isExpanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
          }}>
          <Icon icon={IconType.ArrowBottom} width={10} height={10} />
        </span>
      </div>
      <Collapse in={vm.isExpanded}>
        <div className="mt-3">
          <div className="mb-2">{vm.translate("text1")}</div>
          <div className="mb-2">
            <ReactMarkdown
              className="markdown"
              linkTarget="_blank"
              components={{ a: ({ node, ...props }) => <a {...props} />, p: ({ node, ...props }) => <span {...props} /> }}>
              {vm.text2WithLink}
            </ReactMarkdown>
          </div>
          <div className="mb-2">{vm.translate("administrator")}</div>
        </div>
      </Collapse>
    </div>
  );
});

registerView(GdprInfoView, GdprInfoViewModel);
